import './public-path';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSpectate } from './Utils/Bootstrap';
import { getSpaContainerId } from './Utils/Spectate';
import {
    clientLoaded,
    getClientSettings,
    ucSdkReady,
    setUcLib,
} from './Utils/WrapperIntegration/Ucf';
import {
    intialiseDataLayer,
} from '~shared/utils/google-tag-manager';
import { SpectateApp } from './SpectateApp';

const initialize = (init) => {
    const spaRoot = createRoot(document.getElementById(getSpaContainerId()));
    spaRoot.render(
        <StrictMode>
            <SpectateApp init={init} />
        </StrictMode>
    );
};

intialiseDataLayer();

ucSdkReady()
    .then(
        (ucLib) => {
            setUcLib(ucLib);
            clientLoaded(initialize);
        }
    )
    .then(getClientSettings)
    .then(initSpectate)
    .catch(console.error); //eslint-disable-line
